import type { IEnvironmentModel } from '../../../../libs/commons/src/lib/interfaces/IEnvironmentModel';
import pkg from '../../../../package.json';

export const environment: IEnvironmentModel = {
  e2e: false,
  production: true,
  version: `${pkg?.version ?? '0.0.0'} - Q - (BUILD_INFO)`,
  appInsights: {
    instrumentationKey: 'bd389db0-2e78-4119-a624-42e651089ec1',
  },
  baseUrl: 'https://ultrasonic.dtis-q.dev.dp.schaeffler',
  tenantId: '67416604-6509-4014-9859-45e709f53d3f',

  // SG_DTIS_WEBAPPLICATION_Q
  clientId: '1f16097c-4d53-44b9-a95f-2d84e42af22a',
  appScope: ['api://1f16097c-4d53-44b9-a95f-2d84e42af22a/ROL_USER/read'],

  // SG_DTIS_API_Q
  // https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/d6e508c1-5d8f-4647-b3de-8670f6fddd72
  apiScope: ['api://d6e508c1-5d8f-4647-b3de-8670f6fddd72/access_as_user'],
  loginUrl: 'https://login.microsoftonline.com/',

  postLogoutRedirectUri: window.location.origin,
  redirectUri: window.location.origin,
};
